export default __webpack_public_path__ + "b16633b7bc4d3454f832f70a2bbefe9f.png";